import { CountryService } from './../../../../rest/api/country.service';
import { ScrollHelper } from './../../../../services/scroll-helper.service';
import { HelperService } from './../../../../services/helper.service';
import { AddressService } from './../../../../rest/api/address.service';
import { AuthService } from './../../../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, } from '@angular/forms';
import 'rxjs/add/operator/filter';
import * as _ from 'lodash';

@Component({
  selector: 'app-billing-edit',
  templateUrl: './billing-edit.component.html',
  styleUrls: ['./billing-edit.component.scss']
})
export class BillingEditComponent implements OnInit {
  accessToken: any;
  langShortCode: any;
  billingForm: FormGroup;
  serviceForm: FormGroup;

  isSubmittingBilling = false;
  isSubmittedBilling = false;
  successMsgBilling: any;
  errorMsgBilling: any;
  errorsBilling = [];

  isSubmittingService = false;
  isSubmittedService = false;
  successMsgService: any;
  errorMsgService: any;
  errorsService = [];

  addressData: any;
  billingDetails: any;
  serviceDetails: any;
  countryData: any;

  loading = true;

  billingAddress: any;
  serviceAddress: any;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private authService: AuthService,
    private addressService: AddressService,
    private countryService: CountryService,
    public helperService: HelperService,
    public fb: FormBuilder,
    public fb1: FormBuilder,
    public scrollHelper: ScrollHelper,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.billingFormInit();
    this.serviceFormInit();
  }

  ngOnInit() {
    this.countryService.getCountryName().subscribe((res: any) => {
      this.countryData = res && res.data ? res.data : [];
      this.addressService.getAddressList(this.accessToken).subscribe((res: any) => {
        this.addressData = res && res.data ? res.data : [];
        this.billingAddress = _.find(this.addressData, {type: 'billing'});
        this.serviceAddress = _.find(this.addressData, {type: 'service'});
        this.billingReset(this.billingAddress);
        this.serviceReset(this.serviceAddress);
        this.loading = false;
      }, err => {
        this.loading = false;
      });
    }, err => {
      this.countryData = [];
      this.loading = false;
    });
  }

  // Billing form
  billingFormInit() {
    this.billingForm = this.fb.group({
      country: [''],
      state: ['', Validators.required],
      city: ['', Validators.required ],
      street_address: ['', Validators.required ],
      suite: ['', Validators.required ],
      postal: ['', Validators.required ]
    });
  }

  // ServiceForm
  serviceFormInit() {
    this.serviceForm = this.fb1.group({
      country: [''],
      state: ['', Validators.required],
      city: ['', Validators.required ],
      street_address: ['', Validators.required ],
      suite: ['', Validators.required ],
      postal: ['', Validators.required ]
    });
  }

  billingReset(address) {
    this.billingForm.reset({
      country: address && address.country ? address.country : '',
      state: address && address.state ? address.state : '',
      city: address && address.city ? address.city : '',
      street_address: address && address.street_address ? address.street_address : '',
      suite: address && address.suite ? address.suite : '',
      postal: address && address.postal ? address.postal : '',
    });
  }

  serviceReset(address) {
    this.serviceForm.reset({
      country: address && address.country ? address.country : '',
      state: address && address.state ? address.state : '',
      city: address && address.city ? address.city : '',
      street_address: address && address.street_address ? address.street_address : '',
      suite: address && address.suite ? address.suite : '',
      postal: address && address.postal ? address.postal : '',
    });
  }

  submitBillingForm(value) {
    if (!this.billingForm.valid) {
      this.isSubmittingBilling = true;
      return;
    }
    if (this.isSubmittedBilling) {
      return;
    }
    this.isSubmittedBilling = true;
    this.resetErrors('billing');
    const data = value;
    data.type = 'billing';
    this.submitAddress(data, this.billingAddress);
  }

  submitServiceForm(value) {
    if (!this.serviceForm.valid) {
      this.isSubmittingService = true;
      return;
    }
    if (this.isSubmittedService) {
      return;
    }
    this.isSubmittedService = true;
    this.resetErrors('service');
    const data = value;
    data.type = 'service';
    this.submitAddress(data, this.serviceAddress);
  }


  submitAddress(data, addressData) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    if (addressData && addressData.uuid) {
      this.addressService.updateAddress({
        Authorization: this.accessToken,
        id: addressData.uuid,
        body: formData
      }).subscribe((response: any) => {
        if (data.type === 'billing') {
          this.billingAddress = response && response.data ? response.data : undefined;
          this.billingReset(this.billingAddress);
          this.successMsgBilling = 'Billing address was updated successfully.';
          setTimeout(() => {
            this.resetSuccessMessage(data.type);
          }, 5000);
        }
        if (data.type === 'service') {
          this.serviceAddress = response && response.data ? response.data : undefined;
          this.serviceReset(this.serviceAddress);
          this.successMsgService = 'Service address was updated successfully.';
          setTimeout(() => {
            this.resetSuccessMessage(data.type);
          }, 5000);
        }
        this.resetSubmitValues(data.type);
      }, err => {
        this.resetSubmitValues(data.type);
        this.handleErrors(err, data.type);
      });
    } else {
      this.addressService.storeAddress({
        Authorization: this.accessToken,
        body: formData
      }).subscribe((response: any) => {
        if (data.type === 'billing') {
          this.billingAddress = response && response.data ? response.data : undefined;
          this.billingReset(this.billingAddress);
          this.successMsgBilling = 'Billing address was added successfully.';
          setTimeout(() => {
            this.resetSuccessMessage(data.type);
          }, 5000);
        }
        if (data.type === 'service') {
          this.serviceAddress = response && response.data ? response.data : undefined;
          this.serviceReset(this.serviceAddress);
          this.successMsgService = 'Service address was added successfully.';
          setTimeout(() => {
            this.resetSuccessMessage(data.type);
          }, 5000);
        }
        this.resetSubmitValues(data.type);
      }, err => {
        this.resetSubmitValues(data.type);
        this.handleErrors(err, data.type);
      });
    }
  }

  resetSubmitValues(type) {
    if (type === 'billing') {
      this.isSubmittingBilling = false;
      this.isSubmittedBilling = false;
    }
    if (type === 'service') {
      this.isSubmittingService = false;
      this.isSubmittedService = false;
    }
  }

  handleErrors(err, type) {
    if (err.error && err.error.errors) {
      if (type === 'billing') {
        this.errorsBilling = err.error.errors;
      }
      if (type === 'service') {
        this.errorsService =  err.error.errors;
      }
    } else if (err.error && err.error.error) {
      if (type === 'billing') {
        this.errorMsgBilling = err.error.error;
      }
      if (type === 'service') {
        this.errorMsgService = err.error.error;
      }
    } else {
      if (type === 'billing') {
        this.errorMsgBilling = 'There was error while updating billing address.';
        setTimeout(() => {
          this.resetErrors(type);
        }, 5000);
      }
      if (type === 'service') {
        this.errorMsgService = 'There was error while updating service address.';
        setTimeout(() => {
          this.resetErrors(type);
        }, 5000);
      }
    }
  }

  resetErrors(type) {
    if (type === 'billing') {
      this.errorMsgBilling = undefined;
      this.errorsService = [];
    }
    if (type === 'service') {
      this.errorMsgService =  undefined;
      this.errorsService = [];
    }
  }

  resetSuccessMessage(type) {
    if (type === 'billing') {
      this.successMsgBilling = undefined;
    }
    if (type === 'service') {
      this.successMsgService =  undefined;
    }
  }

}
